export default function (element, options = {}) {
    if (!element) {
        return;
    }

    let { obj = '', act = '', arg} = options;

    element.addEventListener('click', () => {
        if (typeof window[obj]?.[act] === 'function') {
            return window[obj][act](arg);
        } else {
            return window[act]?.(arg);
        }
    });
}
